import { getAppData } from 'optinmonster-js-library/src/vue/utils'

const pages = getAppData('pages', {})

/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 *
 * Most (all?) of these will mirror registered WP pages, which you can find
 * in OMAPI_Pages::get_registered_pages
 * https://github.com/awesomemotive/optin-monster-wp-api/blob/master/OMAPI/Pages.php
 *
 * The "webpackChunkName" comments are important and read by the build process
 * to create various chunked builds for each page. This prevents one monolithic
 * build, and distributes the loading of the resources to when that page is
 * requested.
 */
const routes = [
	{
		name      : 'dashboard',
		component : () => import(
			/* webpackChunkName: "dashboard" */
			'@/pages/Dashboard.vue'
		),
		meta : {
			slug  : 'dashboard',
			title : 'Dashboard',
		},
	},
	{
		name      : 'campaigns',
		component : () => import(
			/* webpackChunkName: "campaigns" */
			'@/pages/Campaigns.vue'
		),
		meta : {
			slug  : 'campaigns',
			title : 'Campaigns',
		},
	},
	{
		name      : 'campaigns-paginated',
		component : () => import(
			/* webpackChunkName: "campaigns" */
			'@/pages/Campaigns.vue'
		),
		meta : {
			slug   : 'campaigns&campaignsPage=:campaignsPage',
			title  : 'Campaigns',
			parent : 'campaigns',
		},
	},
	{
		name      : 'campaigns-paginated-search',
		component : () => import(
			/* webpackChunkName: "campaigns" */
			'@/pages/Campaigns.vue'
		),
		meta : {
			slug   : 'campaigns&campaignsPage=:campaignsPage&searchTerm=:searchTerm',
			title  : 'Campaigns',
			parent : 'campaigns',
		},
	},
	{
		name      : 'campaigns-search',
		component : () => import(
			/* webpackChunkName: "campaigns" */
			'@/pages/Campaigns.vue'
		),
		meta : {
			slug   : 'campaigns&searchTerm=:searchTerm',
			title  : 'Campaigns',
			parent : 'campaigns',
		},
	},
	{
		name      : 'campaign-edit',
		component : () => import(
			/* webpackChunkName: "campaign-edit" */
			'@/pages/Campaign.vue'
		),
		meta : {
			slug  : 'campaigns&campaignId=:campaignId',
			title : 'Campaigns',
		},
	},
	{
		name      : 'templates',
		component : () => import(
			/* webpackChunkName: "templates" */
			'@/pages/Templates.vue'
		),
		meta : {
			title : 'Templates',
		},
	},
	{
		name      : 'template-type',
		component : () => import(
			/* webpackChunkName: "templates" */
			'@/pages/Templates.vue'
		),
		meta : {
			slug   : 'templates&type=:type',
			title  : 'Templates',
			parent : 'templates',
		},
	},
	{
		name      : 'about',
		component : () => import(
			/* webpackChunkName: "about" */
			'@/pages/About.vue'
		),
		meta : {
			title : 'About Us',
		},
	},
	{
		name      : 'about-tab',
		component : () => import(
			/* webpackChunkName: "about" */
			'@/pages/About.vue'
		),
		meta : {
			slug   : 'about&selectedTab=:selectedTab',
			title  : 'About Us',
			parent : 'about',
		},
	},
	{
		name      : 'monsterleads',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			title : 'Subscribers',
		},
	},
	{
		name      : 'monsterleads-tab',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			slug   : 'monsterleads&selectedTab=:selectedTab',
			title  : 'Subscribers',
			parent : 'monsterleads',
		},
	},
	{
		name      : 'monsterleads-paginated-tab',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			slug   : 'monsterleads&selectedTab=:selectedTab&leadsPage=:leadsPage',
			title  : 'Subscribers',
			parent : 'monsterleads',
		},
	},
	{
		name      : 'monsterleads-campaign',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			slug   : 'monsterleads&selectedTab=contacts&campaignId=:campaignId',
			title  : 'Subscribers',
			parent : 'monsterleads',
		},
	},
	{
		name      : 'monsterleads-paginated-campaign',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			slug   : 'monsterleads&selectedTab=contacts&campaignId=:campaignId&leadsPage=:leadsPage',
			title  : 'Subscribers',
			parent : 'monsterleads',
		},
	},
	{
		name      : 'monsterleads-tag',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			slug   : 'monsterleads&selectedTab=contacts&tagId=:tagId',
			title  : 'Subscribers',
			parent : 'monsterleads',
		},
	},
	{
		name      : 'monsterleads-paginated-tag',
		component : () => import(
			/* webpackChunkName: "monsterleads" */
			'@/monsterleads/MonsterLeads.vue'
		),
		meta : {
			slug   : 'monsterleads&selectedTab=contacts&tagId=:tagId&leadsPage=:leadsPage',
			title  : 'Subscribers',
			parent : 'monsterleads',
		},
	},
	{
		name      : 'integrations',
		component : () => import(
			/* webpackChunkName: "integrations" */
			'@/pages/Integrations.vue'
		),
		meta : {
			title : 'Integrations',
		},
	},
	{
		name      : 'onboarding-wizard',
		component : () => import(
			/* webpackChunkName: "onboarding-wizard" */
			'@/pages/OnboardingWizard.vue'
		),
		meta : {
			title : 'Onboarding Wizard',
		},
	},
	{
		name      : 'settings',
		component : () => import(
			/* webpackChunkName: "settings" */
			'@/pages/Settings.vue'
		),
		meta : {
			title : 'Settings',
		},
	},
	{
		name      : 'settings-tab',
		component : () => import(
			/* webpackChunkName: "settings" */
			'@/pages/Settings.vue'
		),
		meta : {
			slug   : 'settings&selectedTab=:selectedTab',
			title  : 'Settings',
			parent : 'settings',
		},
	},
	{
		name      : 'personalization',
		component : () => import(
			/* webpackChunkName: "personalization" */
			'@/pages/Personalization.vue'
		),
		meta : {
			title : 'Personalization',
		},
	},
	{
		name      : 'university',
		component : () => import(
			/* webpackChunkName: "university" */
			'@/pages/University.vue'
		),
		meta : {
			title : 'University',
		},
	},
	// This page is temporary!
	{
		name      : 'connect',
		component : () => import(
			/* webpackChunkName: "connect" */
			'@/pages/Connect.vue'
		),
		meta : {
			title : 'Connect OptinMonster',
		},
	},
	{
		path      : '*',
		name      : '404',
		component : () => import(
			/* webpackChunkName: "temp" */
			'@/pages/404.vue'
		),
		meta : {
			title : '404',
		},
	},
].map(route => {
	const slug = route.meta.slug || route.name

	const pageSlug = `optin-monster-${slug}`
	route.path = route.path || `?page=${pageSlug}`

	if (!route.meta.slug) {
		route.meta.slug = slug
	}

	if (pages[ pageSlug ]) {
		route.meta.title = pages[ pageSlug ]
	}

	return route
})

export default routes
